import { BotId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { dialog } from '../../../lib/bootbox'
import { getApiUrl } from '../../../apiService'

export async function showThoughts(
  botId: BotId,
  modelId: NlpModelId,
  queryId: string,
  token: string
) {
  await dialog({
    title: `Thoughts content`,
    message: `<iframe width="100%" height="500" style="overflow-y:scroll; pointer-events: all;" src="${getApiUrl()}/bots/${botId}/nlp/model/${modelId}/kb/query/${queryId}/thoughts?token=${token}" title="Query thoughts"></iframe>`,
    size: 'lg',
    buttons: {
      close: {
        label: 'Close',
        className: 'btn-secondary',
        callback: () => {
          return true
        }
      }
    }
  })
}
